
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL || 'https://teman.uppaiton.com/api';
const api = axios.create({
    baseURL: apiUrl,
    headers: {
        'x-client-version': process.env.REACT_APP_VERSION ? process.env.REACT_APP_VERSION : '1.0.0',
        'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : undefined
    },
})

// Maintenance mode event listeners
let maintenanceListeners = [];

export const onMaintenanceMode = (callback) => {
    maintenanceListeners.push(callback);
    // Return unsubscribe function
    return () => {
        maintenanceListeners = maintenanceListeners.filter(listener => listener !== callback);
    };
};

const notifyMaintenanceMode = (maintenanceInfo) => {
    maintenanceListeners.forEach(listener => listener(maintenanceInfo));
};

// Manual trigger for maintenance mode (e.g., when starting a restore operation)
export const triggerMaintenanceMode = (customMessage) => {
    const maintenanceInfo = {
        status: 'maintenance',
        message: customMessage || 'Aplikasi sedang dalam pemeliharaan',
        estimatedTime: null,
        contact: null
    };
    notifyMaintenanceMode(maintenanceInfo);
};

// Add response interceptor to handle 503 maintenance mode
api.interceptors.response.use(
    (response) => {
        // If response is successful, return it
        return response;
    },
    (error) => {
        // Check if error response is 503 (maintenance mode)
        if (error.response && error.response.status === 503) {
            const maintenanceInfo = error.response.data;
            notifyMaintenanceMode(maintenanceInfo);
        }
        // Always reject the error so it can be handled by the caller if needed
        return Promise.reject(error);
    }
);

export default api;
export { apiUrl };